import { createVanIconComponent } from "./van"

const GoodsCollect = createVanIconComponent("goods-collect")
export default GoodsCollect
